import React from 'react'
import cx from 'classnames'
import { l } from '@manychat/manyui'

import { IMCTextEditorLegacyProps } from 'components/MCTextEditor'
import { IMCTextEditorRef } from 'components/MCTextEditor/MCTextEditor'

import FlowTextEditor from '../FlowTextEditor'

import styles from './TextInput.module.css'

type TextInputProps = IMCTextEditorLegacyProps & { builderId: string }

const TextInput: React.ForwardRefRenderFunction<IMCTextEditorRef, TextInputProps> = (
  { placeholder, minRows = 2, withVariables, theme, ...props },
  ref,
) => {
  theme = {
    wrapper: cx(styles.input, theme?.wrapper),
    focused: cx(styles.input, theme?.focused),
    invalid: cx(styles.input, theme?.invalid),
    toolbar: cx(styles.toolbar, theme?.toolbar),
    textInput: cx(styles.textInput, theme?.textInput),
  }

  return (
    <FlowTextEditor
      ref={ref}
      {...props}
      placeholder={placeholder ?? l.translate('Enter your text...')}
      minRows={minRows}
      theme={theme}
      withVariables={withVariables}
    />
  )
}

export default React.forwardRef<IMCTextEditorRef, TextInputProps>(TextInput)
